import { Component } from 'react'
import { withTranslation } from 'react-i18next'
import withStyles from 'beam/dist/styles'
import { FormControl, FormLabel, FormHelperText } from 'beam/dist/Form'
import { DatePicker } from 'beam/dist/MuiPickers'
import fieldPropTypes from './FieldPropTypes'
import { get } from 'lodash'

const styles = {
  root: {
    display: 'inline-flex',
  },
}

class FormDatePickerField extends Component {
  handleDateChanged = newDate => {
    const {
      form,
      field: { name },
    } = this.props
    form.setFieldValue(name, newDate)
  }

  render() {
    const {
      classes,
      t,
      label,
      field,
      required,
      form: { errors, touched },
      datePickerProps,
    } = this.props

    return (
      <FormControl
        required={required}
        error={!!get(touched, field.name) && !!get(errors, field.name)}
        fullWidth={true}
        className={classes.root}
      >
        {label && <FormLabel>{label}</FormLabel>}
        <DatePicker
          keyboard
          format="MM/DD/YYYY"
          animateYearScrolling={false}
          t={t}
          {...field}
          onChange={this.handleDateChanged}
          {...datePickerProps}
        />
        {!!get(touched, field.name) && !!get(errors, field.name) && (
          <FormHelperText required={required} error={!!get(touched, field.name) && !!get(errors, field.name)}>
            {!!get(touched, field.name) && get(errors, field.name)}
          </FormHelperText>
        )}
      </FormControl>
    )
  }
}

FormDatePickerField.propTypes = fieldPropTypes
FormDatePickerField.defaultProps = {
  label: '',
  datePickerProps: {},
}

export default withTranslation()(withStyles(styles)(FormDatePickerField))
